import { render, staticRenderFns } from "./CheckoutSummaryLiteral.vue?vue&type=template&id=31943591&"
import script from "./CheckoutSummaryLiteral.vue?vue&type=script&lang=js&"
export * from "./CheckoutSummaryLiteral.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSummaryLiteral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports